import mutations from './mutations.js';
import Actions from './actions.js';
import {Map} from 'immutable';

const displayModule = serviceClient => {
  const actions = Actions(serviceClient);
  return {
    namespaced: true,
    state: () => ({
      displayConditions: [],
      pageCount: 0,
      currentPage: 1,
      fields: [],
      values: Map(),
      editConditions: false,
      conditionToDelete: undefined,
      conditionToEdit: undefined
    }),
    mutations,
    actions
  };
};

export default displayModule;
